import React, { PureComponent } from "react";
import * as Icon from "react-feather";
import { Link } from "react-router-dom";
import { auth } from "../routes/env";

export default class Sidebar extends PureComponent {
  state = {
    hours: new Date().getHours(),
    current_theme: localStorage.getItem("theme-mode"),
    active_tab: window.location.href.split("/")[3],
  };

  setItem = (key, value) => {
    localStorage.setItem(key, value);
  };
  getItem = (key) => {
    return localStorage.getItem(key);
  };

  componentDidMount = () => {
    JSON.stringify(this.state.current_theme) === "null"
      ? this.adaptive(this.state.hours)
      : this.state.current_theme === "dark"
      ? this.adaptive(19) // For dark mode
      : this.adaptive(8); // For light mode
  };

  adaptive = (hours) => {
    if (hours >= 18 || hours <= 7) {
      document
        .getElementById("theme")
        .setAttribute("href", "/assets/css/dark-theme.css");
      this.setState({
        current_theme: "light",
      });
    } else {
      document
        .getElementById("theme")
        .setAttribute("href", "/assets/css/light-theme.css");
      this.setState({
        current_theme: "dark",
      });
    }
  };

  changeTheme = () => {
    if (this.getItem("theme-mode") === "dark") {
      this.setItem("theme-mode", "light");
      this.adaptive(8);
    } else {
      this.setItem("theme-mode", "dark");
      this.adaptive(19);
    }
  };

  set_active = (tab) => {
    this.setState({
      active_tab: tab,
    });
    document.getElementById("sidebarMenu").classList.remove("show");
  };

  logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenDate");
    window.location.href = auth + "/logout";
  };

  render() {
    const { current_theme, active_tab } = this.state;
    return (
      <nav
        id="sidebarMenu"
        className="col-md-3 col-lg-2 d-md-block sidebar collapse pt-5 shadow-sm"
      >
        <div className="text-center d-none d-md-block">
          <a className="navbar-brand" href="/">
            <img
              src="./assets/img/logo/logo.png"
              height="50"
              width="100"
              className="navbar-brand-img mx-auto"
              alt="Wilyer Signage"
            />
          </a>
        </div>
        <div className="position-sticky pt-5">
          <ul className="nav flex-column">
            <li className="nav-item pb-3 text-left ml-3">
              <button
                className={
                  current_theme === null || current_theme === "light"
                    ? "btn btn-white btn-sm rounded-custom px-3 mr-1"
                    : "btn btn-dark btn-sm rounded-custom px-3 mr-1"
                }
                onClick={this.changeTheme}
                id="theme-mode"
              >
                {current_theme === null || current_theme === "light" ? (
                  <span id="theme-name">Light Mode</span>
                ) : (
                  <span id="theme-name">Dark Mode</span>
                )}
              </button>
            </li>
            <li className="nav-item">
              <Link
                to=""
                className={active_tab === "" ? "nav-link active" : "nav-link"}
                aria-current="page"
                onClick={() => this.set_active("")}
              >
                <Icon.Layout size={14} /> Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/clients"
                className={
                  active_tab === "clients" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("clients")}
              >
                <Icon.Users size={14} /> Clients
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/license"
                className={
                  active_tab === "license" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("license")}
              >
                <Icon.Package size={14} /> License
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/willplay"
                className={
                  active_tab === "willplay" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("willplay")}
              >
                <Icon.Tablet size={14} /> Willplay
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/support"
                className={
                  active_tab === "support" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("support")}
              >
                <Icon.Info size={14} /> Support
              </Link>
            </li>
          </ul>

          <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>Documentation</span>
            <span className="link-secondary">
              <Icon.Book size={14} />
            </span>
          </h6>
          <ul className="nav flex-column mb-2">
            <li className="nav-item">
              <Link
                to="/help"
                className={
                  active_tab === "help" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("help")}
              >
                <Icon.HelpCircle size={14} /> Help?
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className={
                  active_tab === "contact" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("contact")}
              >
                <Icon.Mail size={14} /> Contact Us
              </Link>
            </li>
          </ul>
          <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>Account</span>
            <span className="link-secondary">
              <Icon.User size={14} />
            </span>
          </h6>
          <ul className="nav flex-column mb-2">
            <li className="nav-item">
              <Link
                to="/settings"
                className={
                  active_tab === "settings" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("settings")}
              >
                <Icon.Settings size={14} /> Settings
              </Link>
            </li>
            <li className="nav-item">
              <a
                // to="/logout"
                className={
                  active_tab === "logout"
                    ? "nav-link text-danger active"
                    : "nav-link text-danger"
                }
                onClick={this.logout}
              >
                <Icon.Power size={14} color="#dc3545" /> Logout
              </a>
            </li>
          </ul>
          <h6 className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
            <span>Releases</span>
            <a
              className="link-secondary"
              href="javascipt:void(0)"
              aria-label="Add a new report"
            >
              <Icon.Database size={14} />
            </a>
          </h6>
          <ul className="nav flex-column mb-2">
            <li className="nav-item">
              <Link
                to="/updates"
                className={
                  active_tab === "updates" ? "nav-link active" : "nav-link"
                }
                onClick={() => this.set_active("updates")}
              >
                <Icon.Package size={14} /> Updates
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}
